//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Preferences.js";
import "../no/Object.js";
import "../Preferences/Preferences.SessionPreferences.js";
let d=[[[0,"JtUpdateFromSource",1,0],[0,"LockingPolicy",1,0],[0,"MessagesInconsistentRevisions",1,0],[0,"SynchroniseOnLoad",1,0],[0,"SynchroniseOnSave",1,0],[0,"UnpopulatedBehaviour",1,0],[0,"UnpopulatedWithJtBehaviour",1,0]],[[["seed_name"],"SetDefaultSeed",{},1,0]],[]];
SPLM.Preferences.SessionPdm = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Preferences.SessionPdm";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Preferences.SessionPdm.SynchroniseOnLoadType = Object.freeze({
    "Complete" : "Complete", "AddWithTransforms" : "AddWithTransforms", "None" : "None"});

SPLM.Preferences.SessionPdm.SynchroniseOnSaveType = Object.freeze({
    "Complete" : "Complete", "None" : "None"});

SPLM.Preferences.SessionPdm.UnpopulatedBehaviourType = Object.freeze({
    "OnSave" : "OnSave", "ModifiedPrompt" : "ModifiedPrompt", "ModifiedNoPrompt" : "ModifiedNoPrompt", "Never" : "Never", "PreNx4" : "PreNx4"});

SPLM.Preferences.SessionPdm.JtUpdateFromSourceType = Object.freeze({
    "Complete" : "Complete", "None" : "None"});

SPLM.Preferences.SessionPdm.MessagesInconsistentRevisionsType = Object.freeze({
    "None" : "None", "Warning" : "Warning", "Error" : "Error"});

SPLM.Preferences.SessionPdm.LockingPolicyType = Object.freeze({
    "AutocheckinSave" : "AutocheckinSave", "AutocheckinClose" : "AutocheckinClose", "Manual" : "Manual", "Manualplusplus" : "Manualplusplus", "Supermanualplusplus" : "Supermanualplusplus"});

export default SPLM;